<template>
  <div
    id="contactus"
    class="solutions-area section-width ptb-100 faq-contact-area"
  >
    <div class="container wow fadeInUp">
      <div class="section-title">
        <h2>{{ $t("navbar.menu_4_4") }}</h2>
      </div>

      <b-form id="contactForm" :key="formKey">
        <div class="text-center mb-4">
          <span class="fa-stack fa-3x">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fas fa-envelope fa-stack-1x fa-inverse"></i>
          </span>
        </div>
        <b-form-group :label="$t('form.category.label') + $t('form.validation.required_mark')">
          <b-form-select
            v-model="inquiryType"
            :options="inquiryTypeOptions"
            class="form-control"
            id="inquiryType"
          ></b-form-select>
        </b-form-group>
        <b-form-group :label="$t('form.item_1.label') + $t('form.validation.required_mark')">
          <b-form-input
            :placeholder="$t('form.item_1.example')"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('form.item_2.label') + $t('form.validation.required_mark')">
          <b-form-input
            :placeholder="$t('form.item_2.example')"
            type="email"
            required
            id="email"
          ></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('form.item_3.label') + $t('form.validation.required_mark')">
          <VuePhoneNumberInput
            v-model="phone"
            required
            :error="phoneError"
            :translations="{
              countrySelectorLabel: $t('cc'),
              phoneNumberLabel: '0912345678',
              example: $t('ex'),
            }"
            :placeholder="$t('form.item_3.example')"
            @update="is_valid_phone"
          />
          <input
            type="hidden"
            id="phone"
            v-model="formattedNumber"
            class="form-control"
          />
        </b-form-group>

        <b-form-group :label="companyIdLabel">
          <b-form-input
            :placeholder="$t('form.company_id.example')"
            id="companyId"
            v-model="companyId"
            maxlength="8"
            :required="inquiryType !== 'other'"
            @blur="lookupCompanyByTaxId"
          ></b-form-input>
          <small v-if="companyLookupStatus === 'invalid'" class="text-danger">{{ $t("form.validation.company_lookup_invalid") }}</small>
          <small v-else-if="companyLookupStatus === 'loading'" class="text-muted">{{ $t("form.validation.company_lookup_loading") }}</small>
          <small v-else-if="companyLookupStatus === 'notfound'" class="text-danger">{{ $t("form.validation.company_lookup_notfound") }}</small>
          <small v-else-if="companyLookupStatus === 'error'" class="text-danger">{{ $t("form.validation.company_lookup_error") }}</small>
        </b-form-group>
        <b-form-group :label="companyNameLabel">
          <b-form-input
            :placeholder="$t('form.item_4.example')"
            id="companyName"
            v-model="companyName"
            :required="inquiryType !== 'other'"
          ></b-form-input>
        </b-form-group>

        <template v-if="inquiryType === 'venue'">
          <b-form-group :label="$t('form.activity_format.label') + $t('form.validation.required_mark')">
            <b-form-select
              :options="activityFormatOptions"
              class="form-control"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group :label="$t('form.activity_scale.label') + $t('form.validation.required_mark')">
            <b-form-select
              :options="activityScaleOptions"
              class="form-control"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group :label="$t('form.event_date.label') + $t('form.validation.required_mark')">
            <b-form-input type="text" required></b-form-input>
          </b-form-group>
        </template>

        <b-form-group :label="$t('form.item_5.label') + $t('form.validation.required_mark')">
          <b-form-textarea
            id="textarea"
            :placeholder="$t('form.item_5.example')"
            rows="5"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
        <div class="col-lg-12 col-md-12 mb-3">
          <div class="row">
            <div class="col-lg-4"></div>
            <div class="col-lg-4"></div>
            <div class="col-lg-4"></div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12">
          <button
            type="button"
            class="default-btn page-btn btn btn-warning"
            :disabled="isSubmit"
            @click="submitForm"
          >
            <b-spinner v-if="loadingVar"></b-spinner>
            {{ $t("btn") }}
          </button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script scoped>
//import VueRecaptcha from "vue-recaptcha";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
export default {
  name: "ContactUsBody",
  components: {
    VuePhoneNumberInput,
  },
  data() {
    return {
      isSubmit: false,
      formKey: 0,
      apiUrl: `${process.env.VUE_APP_API_URL}/mailer/`,
      passReCAPTCHA: false,
      clientUid: "",
      title: "聯絡我們",
      loadingVar: false,
      token: "",
      phone: "",
      formattedNumber: "",
      valid_phone: false,
      phoneError: false,
      inquiryType: "venue",
      companyName: "",
      companyId: "",
      companyLookupStatus: "",
      // ponytail: same-origin path — nginx must reverse-proxy this to
      // https://data.gcis.nat.gov.tw/od/data/api/5F64D864-61CB-4D0D-8AD9-492047CC1EA6
      // (that upstream has no CORS headers, so it can't be called directly from the browser)
      gcisApiUrl: "/gcis/company",
    };
  },
  computed: {
    companyNameLabel() {
      return (
        this.$t("form.item_4.label") +
        (this.inquiryType === "other"
          ? this.$t("form.validation.optional_mark")
          : this.$t("form.validation.required_mark"))
      );
    },
    companyIdLabel() {
      return (
        this.$t("form.company_id.label") +
        (this.inquiryType === "other"
          ? this.$t("form.validation.optional_mark")
          : this.$t("form.validation.required_mark"))
      );
    },
    inquiryTypeOptions() {
      return ["venue", "cooperation", "other"].map((key) => ({
        value: key,
        text: this.$t(`form.category.options.${key}`),
      }));
    },
    activityFormatOptions() {
      return ["exhibition", "conference", "event", "wedding", "other"].map(
        (key) => ({
          value: key,
          text: this.$t(`form.activity_format.options.${key}`),
        })
      );
    },
    activityScaleOptions() {
      return ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8"].map((key) => ({
        value: key,
        text: this.$t(`form.activity_scale.options.${key}`),
      }));
    },
  },
  activated() {
    if (this.$route.hash === "#contactus") {
      setTimeout(() => {
        const element = document.querySelector(this.$route.hash);
        element.scrollIntoView({ behavior: "smooth" });
      }, 50);
    }
  },
  mounted() {
    // ponytail: clear the red "unfilled" outline live as the visitor types, so it doesn't stay stuck after they fix it
    const clearInvalid = (e) => {
      const el = e.target;
      if (el.classList && el.classList.contains("form-control") && el.value !== "") {
        el.classList.remove("is-invalid");
      }
    };
    // attached to the root, not #contactForm, because the form is remounted after a successful submit
    this.$el.addEventListener("input", clearInvalid);
    this.$el.addEventListener("change", clearInvalid);
  },
  methods: {
    is_valid_phone(payload) {
      this.formattedNumber = payload.formattedNumber;
      this.valid_phone = payload.isValid;
      if (payload.isValid) this.phoneError = false;
    },
    async lookupCompanyByTaxId() {
      const taxId = (this.companyId || "").trim();
      this.companyLookupStatus = "";
      if (!taxId) return;
      if (!/^[0-9]{8}$/.test(taxId)) {
        this.companyLookupStatus = "invalid";
        return;
      }
      this.companyLookupStatus = "loading";
      try {
        const { data } = await this.axios.get(this.gcisApiUrl, {
          params: { taxId },
        });
        if (Array.isArray(data) && data.length > 0 && data[0].Company_Name) {
          this.companyName = data[0].Company_Name;
          this.companyLookupStatus = "found";
          const companyNameEl = document.getElementById("companyName");
          if (companyNameEl) companyNameEl.classList.remove("is-invalid");
        } else {
          this.companyLookupStatus = "notfound";
        }
      } catch (e) {
        this.companyLookupStatus = "error";
      }
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded();

      // Execute reCAPTCHA with action "login".
      this.token = await this.$recaptcha("login");
      if (this.token) {
        this.isSubmit = false;
      }
      // Do stuff with the received token.
      return;
    },
    // isPassReCAPTCHA(val) {
    //   let api = `${this.apiUrl}recapcha`;
    //   const postParams = new URLSearchParams();
    //   postParams.append("g-recaptcha-response", val);
    //   let postConfig = {
    //     withCredentials: true,
    //     headers: {
    //       "Content-Type": "application/x-www-form-urlencoded",
    //     },
    //   };
    //   this.axios
    //     .post(api, postParams.toString(), postConfig)
    //     .then((response) => {
    //       if (response["data"] == "" || response["data"] == undefined) {
    //         alert("驗證失敗 請重新驗證");
    //       } else {
    //         this.passReCAPTCHA = true;
    //         this.clientUid = response["data"];
    //         this.isSubmit = false;
    //       }
    //     });
    // },
    async submitForm() {
      await this.recaptcha();
      if (!this.formVerify()) return;
      this.isSubmit = false;
      this.loadingVar = true;
      let data = {};
      let formInputData = document.querySelectorAll(".form-group");
      for (let i = 0; i < formInputData.length; i++) {
        let keyStash = formInputData[i].querySelector(".col-form-label")
          .innerText.replace(/\s*\*\s*$|(?:\s*（[^）]*）)\s*$/, "");
        let controlEl = formInputData[i].querySelector(".form-control");
        let valStash =
          controlEl.tagName === "SELECT"
            ? controlEl.options[controlEl.selectedIndex].text
            : controlEl.value;

        data[keyStash] = {
          group: "group1",
          content: valStash,
        };
      }
      let api = `${this.apiUrl}sendmail`;
      const postParams = new URLSearchParams();
      postParams.append("MailTo", JSON.stringify(["info@kecc.com.tw"]));
      postParams.append(
        "MailTocc",
        JSON.stringify(["marketing.kec@gmail.com", "marcus@cteam.com.tw"])
      );
      postParams.append("Title", this.title);
      postParams.append("Items", JSON.stringify(data));
      postParams.append("FormId", 11);
      postParams.append("ClientUid", this.clientUid);
      postParams.append("Token", this.token);
      let postConfig = {
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      this.axios
        .post(api, postParams.toString(), postConfig)
        .then((response) => {
          if (parseInt(response["data"]) == 1) {
            this.$swal({
              icon: "success",
              title: "送出表單成功",
            });
            // ponytail: reset all data and remount the form (new key) so every field,
            // the phone widget and the company lookup hint start fresh; failure path keeps input
            Object.assign(this.$data, this.$options.data.call(this), {
              formKey: this.formKey + 1,
            });
          } else {
            this.$swal({
              icon: "error",
              title: "表單送出失敗",
              text: "若重複出現，請聯絡系統管理員。",
            });
          }
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "表單送出失敗",
            text: "若重複出現，請聯絡系統管理員。",
          });
        })
        .finally(() => {
          this.isSubmit = false;
          this.loadingVar = false;
        });
    },
    formVerify() {
      const emailEl = document.querySelector("#email");
      const email = emailEl.value;
      const emailRule = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!emailRule.test(email)) {
        emailEl.classList.add("is-invalid");
        this.$swal({
          icon: "error",
          title: "Email格式錯誤",
          text: "請輸入正確的Email格式，範例：test@gmail.com。",
        });
        return false;
      }
      emailEl.classList.remove("is-invalid");
      if (!this.valid_phone) {
        this.phoneError = true;
        this.$swal({
          icon: "error",
          title: "聯絡方式格式錯誤",
          text: "請輸入正確的聯絡方式格式，範例：0912345678。",
        });
        return false;
      }
      let formInputData = document.querySelectorAll(
        "#contactForm .form-control"
      );
      let optionalIds =
        this.inquiryType === "other" ? ["companyName", "companyId"] : [];
      let hasEmpty = false;
      let firstInvalidEl = null;
      for (let i = 0; i < formInputData.length; i++) {
        const el = formInputData[i];
        if (el.type === "hidden" || optionalIds.includes(el.id)) {
          el.classList.remove("is-invalid");
          continue;
        }
        if (el.value == "") {
          el.classList.add("is-invalid");
          hasEmpty = true;
          if (!firstInvalidEl) firstInvalidEl = el;
        } else {
          el.classList.remove("is-invalid");
        }
      }
      if (hasEmpty) {
        this.$swal({
          icon: "error",
          title: "表單內有未填入的欄位",
          text: this.$t("form.validation.unfilled_fields"),
        });
        firstInvalidEl.focus();
        return false;
      }
      return true;
    },
  },
};
</script>

<style>
#contactForm .form-control {
  color: #1a1a1a;
}
#contactForm .form-control::placeholder {
  color: #adb5bd;
  font-style: italic;
  opacity: 1;
}
#contactForm .form-control.is-invalid {
  border-color: #dc3545;
  background-image: none;
}
.input-tel__input,
.country-selector__input {
  background-color: #f2f9fc !important;
  height: 50px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  border: 1px solid #e8e8e8 !important;
  box-shadow: none !important;
  caret-color: aquamarine !important;
}
.input-tel__input:focus,
.country-selector__input:focus {
  border: 1px solid #06b1d8 !important;
}
.fa-stack {
  color: #33ccff;
}

#contactus .container {
  max-width: 1000px;
}

.juc-card-icon {
  height: 96px;
}

.jsc-card-body {
  height: 360px !important;
  margin: 0px 10px;
}

.jsc-work-btn {
  height: 100px;
  font-size: 28px;
}

.jsc-work-btn a {
  color: #fff;
}

.jsc-card {
  margin-bottom: 30px;
}

.jsc-card .card {
  /* height: 32vh !important; */
  border: 1px solid #2680ff;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.fa-external-link-alt:before {
  margin-left: 12px;
}

.juc-title h1 {
  font-size: 50px;
  color: #2680ff;
  margin-bottom: 30px;
}

.juc-card-icon i {
  margin-top: 30px;
  color: #2680ff;
  font-size: 4rem;
}

.jsc-icon-title {
  font-size: 34px;
  color: #2680ff;
  margin-bottom: 15px;
}

.jsc-content {
  font-size: 18px;
}

@media (max-width: 1200px) {
  /* Extra large devices (large desktops, 1200px and down) */
}

@media (max-width: 992px) {
  /* Large devices (desktops, 992px and down) */
  #joinus .container {
    max-width: 700px;
  }
}

@media (max-width: 768px) {
  #joinus .container {
    max-width: 600px;
  }

  /*  Medium devices (tablets, 768px and down) */
}

@media (max-width: 576px) {
  /*  Small devices (landscape phones, 576px and down) */
  .juc-card-icon i {
    margin-top: 5px;
  }

  #joinus .container {
    max-width: 400px;
  }
}
</style>
